/**
 * Roles allowed to mutate a worker identity/profile through
 * `updateStaffProfileAction`. Worker 360 Edit worker must use this same
 * allow-list so the primary button is not shown to roles that will fail save.
 */
export const STAFF_PROFILE_EDIT_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'OWNER',
  'FACILITY_MANAGER',
  'REGION_MANAGER',
  'COORDINATOR',
  'HR_OFFICER',
] as const;

export type StaffProfileEditRole = (typeof STAFF_PROFILE_EDIT_ROLES)[number];

export function canEditWorkerProfile(role: string | null | undefined): boolean {
  const normalised = String(role ?? '').toUpperCase();
  return (STAFF_PROFILE_EDIT_ROLES as readonly string[]).includes(normalised);
}
